import { render, staticRenderFns } from "./ServiceQrcode.vue?vue&type=template&id=2ca894a2&scoped=true&"
import script from "./ServiceQrcode.vue?vue&type=script&lang=js&"
export * from "./ServiceQrcode.vue?vue&type=script&lang=js&"
import style0 from "./ServiceQrcode.vue?vue&type=style&index=0&id=2ca894a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca894a2",
  null
  
)

export default component.exports